import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Machinetype} from './machinetype';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MachinetypeService
{
    token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNTQ1Mzk5NTI3LCJleHAiOjE1NDc5OTE1Mjd9.0URrNPOC_hDdxivMN480Ar6gjUzssbm8syi6q1AoLuY"

    constructor(private http: HttpClient) { 

    }
    machinetypeurl = environment.appURL+"/machinetypes";
  

 getMachinetypes() 
{
  return this.http.get<Machinetype[]>(this.machinetypeurl,{headers: new HttpHeaders({"Authorization":"Bearer " + this.token})})
  .pipe(
    tap(_ => console.log('fetched machinetypes')),
    catchError(this.handleError('getMachinetypes', []))
  );
}

getMachinetype(id: number)
{
  const url = `${this.machinetypeurl}/${id}`;
  console.log(url);
  return this.http.get<Machinetype>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + this.token})})
  .pipe(
    tap(_ => console.log('fetched machinetypes')),
    catchError(this.handleError<Machinetype>(`getMachinetype id=${id}`))
  );
 }


 updateMachinetype (machinetype: Machinetype): Observable<any> {
   let upd = "machinetype=" + machinetype.type 
  return this.http.put(this.machinetypeurl +"/"+ machinetype.id, upd , {headers: new HttpHeaders({"Authorization":"Bearer " + this.token, "Content-Type": "application/x-www-form-urlencoded"})})
  .pipe(
    tap(_ => console.log(`updated machinetype id=${machinetype.id}`)),
    catchError(this.handleError<any>('updateMachinetype'))
  );
}


private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}